import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { lazy, Suspense } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var UserMenuContent = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-user-menu-content" */"./UserMenuContent");
});
var LazyUserMenuContent = function LazyUserMenuContent(props) {
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(UserMenuContent, _objectSpread({}, props))
  });
};
export default LazyUserMenuContent;